import styles from './TermsPage.module.css';
import React, { useEffect, useState } from 'react';
import {
  Footer,
  Navbar,
  getDefaultLanguageHandler,
  Languages,
  LanguageSelector,
  SelectedLanguage
} from 'abu-common-components';
import TermsAndConditions from '../../components/termsAndConditions/TermsAndConditions';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const TermsPage = () => {
  const { i18n } = useTranslation();
  const defaultLanguage = getDefaultLanguageHandler(i18n, Languages);
  const [language, setLanguage] = useState(defaultLanguage);
  const [openLanguageModal, setOpenLanguageModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Terms & Conditions | Booking.com';
  }, []);
  return (
    <>
      {openLanguageModal && (
        <LanguageSelector
          availableLanguages={Languages}
          changeLanguage={setLanguage}
          language={language}
          toggleLanguageModal={setOpenLanguageModal}
        />
      )}
      <div className={styles.homeContainer} data-testid="termPageTestId">
        <div className={styles.selectedLanguageContainer}>
          <SelectedLanguage
            language={language}
            changeLanguageModal={setOpenLanguageModal}
            hoverStyle={{
              onHoverLanguage: '#FFFFFF',
              backgroundColorLanguage: 'rgba(0,0,0,0.06)'
            }}
          />
        </div>
        <div className={styles.navBar}>
          <Navbar />
        </div>
        <TermsAndConditions />
        <div className={styles.footerContent}>
          <Footer onTermsClick={() => navigate('/terms')} />
        </div>
      </div>
    </>
  );
};

export default TermsPage;
